import React from "react";
import { ReactComponent as Checkmark } from "../assets/icons/checkmark.svg";
import { ReactComponent as Exclamation } from "../assets/icons/InfoNotification.svg";
import { ReactComponent as Cross } from "../assets/icons/ErrorNotification.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { isEmptyObject } from "jquery";

const iconLookup = {
  success: <Checkmark />,
  info: <Exclamation />,
  error: <Cross />,
  warning:<Exclamation />,
};

export const notify = (text, type = "success", icon = null) => {
  const toastStyles = {
    success: {},
    info: {},
    error: {},
    warning: {
      background: '#ff0000', // Red color
      color: '#ffffff'       // White text
    }
  };
  if(type !== "error"){
    toast(text, {
    type: type,
    icon: () => (icon ? icon : iconLookup[type]),
    closeButton: false,
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "colored",
    style: toastStyles[type]
  });
  }else {
    console.log(type,text);
  }
  // toast(text, {
  //   type: type,
  //   icon: () => (icon ? icon : iconLookup[type]),
  //   closeButton: false,
  //   position: "top-right",
  //   autoClose: 5000,
  //   hideProgressBar: true,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: false,
  //   theme: "colored",
  // });
};

export const getInitials = (name) => {
  if (!name || name?.length === 0) {
    return "?";
  }
  name = name.split(" ");
  let initials = "";
  if (name.length > 1) {
    initials = `${name[0].charAt(0)}${name[1].charAt(0)}`;
  } else if (name[0].length > 1) {
    initials = `${name[0].charAt(0)}${name[0].charAt(1)}`;
  } else {
    initials = name[0].charAt(0);
  }
  return initials.toUpperCase();
};

export const formDataHelper = (formData, ignoreBlanks = false) => {
  const result = {};
  for (const [key, value] of formData.entries()) {
    if (ignoreBlanks) {
      if (value && value !== "null") {
        result[key] = value;
      }
    } else {
      result[key] = value;
    }
  }

  return result;
};

export const getCountOfInactive = (last_active) => {
  const today = new Date();
  today.setDate(today.getDate() - 30);
  const lastActive = new Date(last_active);
  return lastActive < today;
};

export const getCountOfNewPatient = (item) => {
  if (!item?.created) return false;
  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);
  return new Date(item.created) >= thirtyDaysAgo;
};

export const getTagBasedOnScore = (score, tag_group) => {
  let tags = [];
  if (tag_group)
    // eslint-disable-next-line prefer-destructuring
    tags = tag_group.tags;
  if (tags.length === 0) return "No Tag Group";

  let returnTag = "";

  tags.forEach((element) => {
    if (score >= element.low_bound && score <= element.high_bound)
      returnTag = element.label;
  });

  return returnTag;
};

export const getMaxScoreBasedOnAnswerGroups = (answer_group, questionnaire) => {
  return (
    answer_group?.answers[answer_group?.answers.length - 1]?.score *
      questionnaire?.length || 0
  );
};

export function generateYAxisTicks(numbers) {
  numbers = new Set(numbers);
  numbers = Array.from(numbers);
  if (numbers.length === 0) {
    return [];
  }

  function generateEvenlySpreadArray(numbers) {
    const maxNumber = Math.max(...numbers);
    const interval = maxNumber / 4;
    const evenlySpreadArray = [];

    for (let i = 0; i < 5; i++) {
      const value = Math.round(i * interval);
      evenlySpreadArray.push(value);
    }

    return evenlySpreadArray;
  }
  const yAxisLookup = ["😭 Awful", "😢 Bad", "🙂 Okay", "😁 Good", "😄 Great"];
  const yAxisNumbers = {};

  function roundUpToMultipleOfTwo(numbers) {
    const roundedNumbers = [];

    for (const number of numbers) {
      const rounded = Math.ceil(number / 2) * 2;
      roundedNumbers.push(rounded);
    }

    return roundedNumbers;
  }

  const sequence = generateEvenlySpreadArray(numbers);
  roundUpToMultipleOfTwo(sequence).forEach((item, index) => {
    yAxisNumbers[item] = yAxisLookup[index];
  });

  return yAxisNumbers;
}

export const selectDateFilter = (
  timespan,
  today,
  endDate,
  setStartDate,
  setEndDate
) => {
  // Set Monday as the first day of the week
  moment.updateLocale('en', { week: {  dow: 1 }});
  const now = moment();

  if (timespan === "Past Week" || timespan === "pastweek") {
    // Previous week's Monday to Sunday
    const startOfCurrentWeek = now.clone().startOf("week");
    const pastWeekStartDate = startOfCurrentWeek.clone().subtract(7, "days");
    const pastWeekEndDate = startOfCurrentWeek.clone().subtract(1, "days");
    setStartDate(pastWeekStartDate.format("YYYY-MM-DD"));
    setEndDate(pastWeekEndDate.format("YYYY-MM-DD"));
  }

  if (timespan === "This Week" || timespan === "week") {
    // Current week's Monday to today
    const currentWeekStartDate = now.clone().startOf("week");
    setStartDate(currentWeekStartDate.format("YYYY-MM-DD"));
    setEndDate(now.format("YYYY-MM-DD"));
  }

  if (timespan === "2 Week" || timespan === "2week") {
    const pastTwoWeeksStartDate = now.clone().subtract(14, "days");
    setStartDate(pastTwoWeeksStartDate.format("YYYY-MM-DD"));
    setEndDate(now.format("YYYY-MM-DD"));
  }

  if (timespan === "This Month" || timespan === "month") {
    const startOfMonth = now.clone().startOf("month");
    setStartDate(startOfMonth.format("YYYY-MM-DD"));
    setEndDate(now.format("YYYY-MM-DD"));
  }

  if (timespan === "3 Months" || timespan === "3months") {
    const threeMonthsAgo = now.clone().subtract(3, "months");
    setStartDate(threeMonthsAgo.format("YYYY-MM-DD"));
    setEndDate(now.format("YYYY-MM-DD"));
  }

  if (timespan === "6 Months" || timespan === "6months") {
    const sixMonthsAgo = now.clone().subtract(6, "months");
    setStartDate(sixMonthsAgo.format("YYYY-MM-DD"));
    setEndDate(now.format("YYYY-MM-DD"));
  }
};

export const getToday = () => {
  let today = new Date();
  today = moment(today).format("YYYY-MM-DD");
  return today;
};

export const bytesToSize = (bytes, seperator = "") => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "n/a";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes}${seperator}${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)}${seperator}${sizes[i]}`;
};

export const getPrivilegeExipryRTM = (expirationTime = 36000) => {
  const expirationTimeInSeconds = expirationTime;
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const privilegeExpiredTs = currentTimestamp + expirationTimeInSeconds;
  return privilegeExpiredTs;
};

export const smartJoin = (array) => {
  // Filter out any falsy values to prevent leading commas
  const filteredArray = array.filter(item => item && item.trim());
  if (filteredArray.length === 0) return "";

  if (filteredArray.length === 1) return filteredArray[0];

  return [
    ...filteredArray.slice(0, -2),
    filteredArray.slice(-2).join(" and "),
  ].join(", ");
};

export const capitalizeText = (string) => {
  return string.replace(/\b\w/g, (l) => l.toUpperCase());
};

const ALLOWED_DOMAINS = [
  "zoom.us",
  "meet.google.com",
  "teams.microsoft.com",
  "doxy.me",
	"gethealthie.com",
  "carepatron.com",
  "surrymedicalministries.com"
];
export const isAllowedMeetingURL = (url) => {
  try {
    // const fullURL = url.startsWith("http") ? url : `https://${url}`;
		const fullURL = url.trim().replace(/[.,)\]\s]+$/, '');
    const parsed = new URL(fullURL);
    const hostname = parsed.hostname.toLowerCase();
    const isAllowed = ALLOWED_DOMAINS.some(allowed => 
      hostname === allowed || hostname.endsWith(`.${allowed}`)
    );
    console.log(`[isAllowedMeetingURL] URL: ${url}, Hostname: ${hostname}, Allowed: ${isAllowed}`);
    return isAllowed;
  } catch (err) {
    console.warn(`[isAllowedMeetingURL] Invalid URL: ${url}`, err);
    return false;
  }
};

export const containsDisallowedURL = (text) => {
  // const urlRegex = /\b((https?:\/\/)?(www\.)?[\w.-]+\.[\w]{2,}(\/[^\s]*)?)\b/g;
		const urlRegex = /https?:\/\/[^\s]+/g;
  const matches = text.match(urlRegex) || [];
  const disallowed = matches.some(url => !isAllowedMeetingURL(url));
  matches.forEach(url =>
    console.log(`[containsDisallowedURL] URL: ${url}, Disallowed: ${!isAllowedMeetingURL(url)}`)
  );
  return disallowed;
};

export const urlify = (text) => {
  // const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
		const urlRegex = /https?:\/\/[^\s]+/g;  //more stricter regex
  return text.replace(urlRegex, (url, b, c) => {
    const url2 = c === "www." ? "https://" + url : url;
    let parsed;
    try {
      parsed = new URL(url2);
    } catch {
      return `<span style="color: red;" title="Unsupported or invalid link">${url}</span>`;
    }

    const hostname = parsed.hostname.toLowerCase();
    let previewText = "🔗 Meeting Link";

    // if (hostname.includes("zoom.us")) {
    //   previewText = "Join Zoom Meeting";
    // } else if (hostname.includes("meet.google.com")) {
    //   previewText = "Join Google Meet";
    // } else if (hostname.includes("teams.microsoft.com")) {
    //   previewText = "Join Teams Meeting";
    // } else if (hostname.includes("doxy.me")) {
    //   previewText = "Join Doxy Call";
    // } else if (hostname.includes("gethealthie.com")) {
    //   previewText = "Join Healthie Session";
    // }

     return isAllowedMeetingURL(url2)
  ? `<br /><a href="${url2}" target="_blank" rel="noopener noreferrer">${previewText}</a><br />`
  : `<span style="color: red;" title="Unsupported or unsafe link">${url}</span>`;
  });
};


export const playMessageSound = (type = "incoming") => {
  const soundHashmap = {
    incoming: "incomingMessageSound",
    activeChat: "activeChatMessageSound",
  };
  try {
    const soundElement = document.getElementById(
      soundHashmap[type] || soundHashmap["incoming"]
    );

    if (soundElement) {
      soundElement.muted = false;
      try {
        soundElement.stop();
      } catch (e) {}
      soundElement.play();
    } else {
      //* Just in case the audio element was not found.
      notify("You have a new message!", "info");
    }
  } catch (e) {
    console.log(
      "Something went wrong while playing message sound!\nShowing info-card instead."
    );
    notify("You have a new message!", "info");
  }
};

export const generateMonthlyObjectsReverse = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // JavaScript months are zero-based, so we add 1.

  const months = [];
  for (let month = currentMonth; month >= 1; month--) {
    const monthLabel = new Date(currentYear, month - 1).toLocaleString(
      "en-us",
      { month: "short" }
    );
    const monthValue = `${currentYear}-${month.toString().padStart(2, "0")}-01`;
    months.push({ label: `${monthLabel} ${currentYear}`, value: monthValue });
  }

  return months;
  // Usage example:
  // const monthlyObjectsReverse = generateMonthlyObjectsReverse();
  // console.log(monthlyObjectsReverse);
};

export const findPrevMonth = (target) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); //2023
  const currentMonth = currentDate.getMonth(); //Starts from 0
  if (currentMonth !== 0) {
    const selectedDate = new Date(target?.value || target);
    return `${selectedDate.getFullYear()}-${
      selectedDate.getMonth() < 10
        ? "0" + selectedDate.getMonth()
        : selectedDate.getMonth()
    }-01`;
  }
  return `${currentYear - 1}-12-01`;
};

export const findClinician = (staffData, clinicianID) => {
  const targetStaff = staffData.find((e) => {
    if (e?.id === clinicianID) {
      return e;
    }
  });
  return targetStaff;
};

export const getFullName = (personObject) => {
  if (isEmptyObject(personObject)) {
    return "";
  }
  return `${personObject?.first_name} ${personObject?.last_name}`;
};

export const reportStatus = (bhiPatient, id) => {
  let status = "not ready";
  if (bhiPatient?.length > 0) {
    const target = bhiPatient.find((ele) => {
      if (ele.id === id) {
        return ele;
      }
    });
    if (target) {
      status = "ready";
    }
  }

  return status;
};

export const sortDates = (datesArray) => {
  try {
    const res = datesArray.sort((a, b) => {
      return new Date(a) - new Date(b);
    });

    return res;
  } catch (e) {
    return false;
  }
};

export const formatUTC = (dateInt, addOffset = false) => {
  let date = !dateInt || dateInt.length < 1 ? new Date() : new Date(dateInt);
  if (typeof dateInt === "string") {
    return date;
  } else {
    const offset = addOffset
      ? date.getTimezoneOffset()
      : -date.getTimezoneOffset();
    const offsetDate = new Date();
    // offsetDate.setTime(date.getTime() + offset * 60000); // Previous Logic
    offsetDate.setTime(date.getTime());   // New Logic Added
    return offsetDate;
  }
};

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getPastMonthsListWithNames = (numMonths) => {
  const currentDate = new Date();
  const monthsList = [];
  const cmonthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  for (let i = 0; i < numMonths; i++) {
    const monthName = cmonthNames[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    monthsList.push(`${monthName} ${year}`);

    // Move back one month for the next iteration
    currentDate.setMonth(currentDate.getMonth() - 1);
  }
  return monthsList;
};
